<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-group label-for="input-email">
      <template #label>
        Email
      </template>
      <b-form-input id="input-email" v-model="form.email" :state="isValidField('email')" placeholder="eg., yourname@company.com" class="rounded-pill" />
      <b-form-invalid-feedback :state="isValidField('email')">
        <div v-for="error in errors.email || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-row class="mt-5 justify-content-center">
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Submit</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import MixinForm from './MixinForm'

export default {
  name: 'ForgotWorkspaceForm',

  mixins: [MixinForm],

  data() {
    return {
      form: {
        email: ''
      }
    }
  },

  methods: {
    validate(data) {
      const errors = {}
      if (data.email && !validator.isEmail(data.email.trim())) errors.email = ['Email format is invalid']
      return errors
    }
  }
}
</script>
